import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useOrderGroupedByShipmentsQuery = createQueryHook(
  OrderApiClient.getOrderGroupedByShipments,
  {
    queryKey: ['orderGroupedByShipments'],
    select: (data) => ({
      ...data,
      message: decodeHtmlEntities(data.message),
      offers: data.offers.map((offer) => ({
        ...offer,
        offer: {
          ...offer.offer,
          name: decodeHtmlEntities(offer.offer.name),
        },
      })),
      shipments: data.shipments.map((shipment) => ({
        ...shipment,
        offers: shipment.offers.map((offer) => ({
          ...offer,
          offer: {
            ...offer.offer,
            name: decodeHtmlEntities(offer.offer.name),
          },
        })),
      })),
    }),
  },
)
